import { useState } from "react";

const START_YEAR = 2022;
const CURRENT_YEAR = new Date().getFullYear();

const years = Array.from(
  { length: CURRENT_YEAR - START_YEAR + 1 },
  (_, i) => START_YEAR + i
);

const formatDate = (date) => {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const Declaracao = () => {
  const [selectedYear, setSelectedYear] = useState(CURRENT_YEAR);
  const today = formatDate(new Date());
  const isCurrentYear = selectedYear === CURRENT_YEAR;

  return (
    <div className="p-6 md:p-8 max-w-4xl mx-auto space-y-8">
      <div className="flex items-center gap-4">
        <label htmlFor="year-select" className="text-sm font-semibold text-gray-700 whitespace-nowrap">
          Selecionar exercício:
        </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {years.map((year) => (
            <option key={year} value={year}>
              Exercício - {year}
            </option>
          ))}
        </select>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-6 md:p-8 space-y-6 shadow-sm">
        {isCurrentYear && (
          <h2 className="text-xl font-bold text-gray-900 uppercase tracking-wide">
            Declaração
          </h2>
        )}

        <p className="text-gray-700 leading-relaxed">
          A Prefeitura de Serrinha informa que, até a presente data ({today}), não
          foram identificados registros relativos ao conteúdo destinado a esta
          página, conforme consulta ao sistema oficial responsável por essa
          divulgação:
        </p>

        {isCurrentYear ? (
          <ul className="space-y-1">
            {years.map((year) => (
              <li key={year} className="text-gray-700 font-medium">
                Exercício - {year}
              </li>
            ))}
          </ul>
        ) : (
          <div className="space-y-1">
            <p className="text-gray-700 font-medium">Convênios - Transferências Realizadas</p>
            <p className="text-gray-700">Exercício: {selectedYear}</p>
          </div>
        )}

        <p className="text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-4">
          Esta declaração atende à recomendação do Tribunal de Contas, garantindo
          a transparência ativa mesmo na ausência de fatos geradores.
        </p>
      </div>
    </div>
  );
};

export default Declaracao;
